/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProductsquerySalesarticlesBrandBrandGet } from '../fn/sales-articles/api-productsquery-salesarticles-brand-brand-get';
import { ApiProductsquerySalesarticlesBrandBrandGet$Params } from '../fn/sales-articles/api-productsquery-salesarticles-brand-brand-get';
import { apiProductsquerySalesarticlesBrandBrandGet$Plain } from '../fn/sales-articles/api-productsquery-salesarticles-brand-brand-get-plain';
import { ApiProductsquerySalesarticlesBrandBrandGet$Plain$Params } from '../fn/sales-articles/api-productsquery-salesarticles-brand-brand-get-plain';
import { apiProductsquerySalesarticlesCategoryCategoryIdGet } from '../fn/sales-articles/api-productsquery-salesarticles-category-category-id-get';
import { ApiProductsquerySalesarticlesCategoryCategoryIdGet$Params } from '../fn/sales-articles/api-productsquery-salesarticles-category-category-id-get';
import { apiProductsquerySalesarticlesCategoryCategoryIdGet$Plain } from '../fn/sales-articles/api-productsquery-salesarticles-category-category-id-get-plain';
import { ApiProductsquerySalesarticlesCategoryCategoryIdGet$Plain$Params } from '../fn/sales-articles/api-productsquery-salesarticles-category-category-id-get-plain';
import { apiProductsquerySalesarticlesHighlightedGet } from '../fn/sales-articles/api-productsquery-salesarticles-highlighted-get';
import { ApiProductsquerySalesarticlesHighlightedGet$Params } from '../fn/sales-articles/api-productsquery-salesarticles-highlighted-get';
import { apiProductsquerySalesarticlesHighlightedGet$Plain } from '../fn/sales-articles/api-productsquery-salesarticles-highlighted-get-plain';
import { ApiProductsquerySalesarticlesHighlightedGet$Plain$Params } from '../fn/sales-articles/api-productsquery-salesarticles-highlighted-get-plain';
import { apiProductsquerySalesarticlesQuickSearchGet } from '../fn/sales-articles/api-productsquery-salesarticles-quick-search-get';
import { ApiProductsquerySalesarticlesQuickSearchGet$Params } from '../fn/sales-articles/api-productsquery-salesarticles-quick-search-get';
import { apiProductsquerySalesarticlesQuickSearchGet$Plain } from '../fn/sales-articles/api-productsquery-salesarticles-quick-search-get-plain';
import { ApiProductsquerySalesarticlesQuickSearchGet$Plain$Params } from '../fn/sales-articles/api-productsquery-salesarticles-quick-search-get-plain';
import { apiProductsquerySalesarticlesSearchGet } from '../fn/sales-articles/api-productsquery-salesarticles-search-get';
import { ApiProductsquerySalesarticlesSearchGet$Params } from '../fn/sales-articles/api-productsquery-salesarticles-search-get';
import { apiProductsquerySalesarticlesSearchGet$Plain } from '../fn/sales-articles/api-productsquery-salesarticles-search-get-plain';
import { ApiProductsquerySalesarticlesSearchGet$Plain$Params } from '../fn/sales-articles/api-productsquery-salesarticles-search-get-plain';
import { apiProductsquerySalesarticlesSummaryIdGet } from '../fn/sales-articles/api-productsquery-salesarticles-summary-id-get';
import { ApiProductsquerySalesarticlesSummaryIdGet$Params } from '../fn/sales-articles/api-productsquery-salesarticles-summary-id-get';
import { apiProductsquerySalesarticlesSummaryIdGet$Plain } from '../fn/sales-articles/api-productsquery-salesarticles-summary-id-get-plain';
import { ApiProductsquerySalesarticlesSummaryIdGet$Plain$Params } from '../fn/sales-articles/api-productsquery-salesarticles-summary-id-get-plain';
import { apiProductsquerySalesarticlesSummaryIdsGet } from '../fn/sales-articles/api-productsquery-salesarticles-summary-ids-get';
import { ApiProductsquerySalesarticlesSummaryIdsGet$Params } from '../fn/sales-articles/api-productsquery-salesarticles-summary-ids-get';
import { apiProductsquerySalesarticlesSummaryIdsGet$Plain } from '../fn/sales-articles/api-productsquery-salesarticles-summary-ids-get-plain';
import { ApiProductsquerySalesarticlesSummaryIdsGet$Plain$Params } from '../fn/sales-articles/api-productsquery-salesarticles-summary-ids-get-plain';
import { apiProductsquerySalesarticlesTemporarydiscountsGet } from '../fn/sales-articles/api-productsquery-salesarticles-temporarydiscounts-get';
import { ApiProductsquerySalesarticlesTemporarydiscountsGet$Params } from '../fn/sales-articles/api-productsquery-salesarticles-temporarydiscounts-get';
import { apiProductsquerySalesarticlesTemporarydiscountsGet$Plain } from '../fn/sales-articles/api-productsquery-salesarticles-temporarydiscounts-get-plain';
import { ApiProductsquerySalesarticlesTemporarydiscountsGet$Plain$Params } from '../fn/sales-articles/api-productsquery-salesarticles-temporarydiscounts-get-plain';
import { apiProductsquerySalesarticlesUrlIdDetailsGet } from '../fn/sales-articles/api-productsquery-salesarticles-url-id-details-get';
import { ApiProductsquerySalesarticlesUrlIdDetailsGet$Params } from '../fn/sales-articles/api-productsquery-salesarticles-url-id-details-get';
import { apiProductsquerySalesarticlesUrlIdDetailsGet$Plain } from '../fn/sales-articles/api-productsquery-salesarticles-url-id-details-get-plain';
import { ApiProductsquerySalesarticlesUrlIdDetailsGet$Plain$Params } from '../fn/sales-articles/api-productsquery-salesarticles-url-id-details-get-plain';
import { SalesArticleDto } from '../models/sales-article-dto';
import { SalesArticleSimpleSummary } from '../models/sales-article-simple-summary';
import { SalesArticleSummary } from '../models/sales-article-summary';

@Injectable({ providedIn: 'root' })
export class SalesArticlesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProductsquerySalesarticlesSearchGet()` */
  static readonly ApiProductsquerySalesarticlesSearchGetPath = '/api/productsquery/salesarticles/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesSearchGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesSearchGet$Plain$Response(params?: ApiProductsquerySalesarticlesSearchGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsquerySalesarticlesSearchGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesSearchGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesSearchGet$Plain(params?: ApiProductsquerySalesarticlesSearchGet$Plain$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsquerySalesarticlesSearchGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesSearchGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesSearchGet$Response(params?: ApiProductsquerySalesarticlesSearchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsquerySalesarticlesSearchGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesSearchGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesSearchGet(params?: ApiProductsquerySalesarticlesSearchGet$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsquerySalesarticlesSearchGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /** Path part for operation `apiProductsquerySalesarticlesQuickSearchGet()` */
  static readonly ApiProductsquerySalesarticlesQuickSearchGetPath = '/api/productsquery/salesarticles/quick-search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesQuickSearchGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesQuickSearchGet$Plain$Response(params?: ApiProductsquerySalesarticlesQuickSearchGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSimpleSummary>>> {
    return apiProductsquerySalesarticlesQuickSearchGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesQuickSearchGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesQuickSearchGet$Plain(params?: ApiProductsquerySalesarticlesQuickSearchGet$Plain$Params, context?: HttpContext): Observable<Array<SalesArticleSimpleSummary>> {
    return this.apiProductsquerySalesarticlesQuickSearchGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSimpleSummary>>): Array<SalesArticleSimpleSummary> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesQuickSearchGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesQuickSearchGet$Response(params?: ApiProductsquerySalesarticlesQuickSearchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSimpleSummary>>> {
    return apiProductsquerySalesarticlesQuickSearchGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesQuickSearchGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesQuickSearchGet(params?: ApiProductsquerySalesarticlesQuickSearchGet$Params, context?: HttpContext): Observable<Array<SalesArticleSimpleSummary>> {
    return this.apiProductsquerySalesarticlesQuickSearchGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSimpleSummary>>): Array<SalesArticleSimpleSummary> => r.body)
    );
  }

  /** Path part for operation `apiProductsquerySalesarticlesUrlIdDetailsGet()` */
  static readonly ApiProductsquerySalesarticlesUrlIdDetailsGetPath = '/api/productsquery/salesarticles/{urlId}/details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesUrlIdDetailsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesUrlIdDetailsGet$Plain$Response(params: ApiProductsquerySalesarticlesUrlIdDetailsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesArticleDto>> {
    return apiProductsquerySalesarticlesUrlIdDetailsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesUrlIdDetailsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesUrlIdDetailsGet$Plain(params: ApiProductsquerySalesarticlesUrlIdDetailsGet$Plain$Params, context?: HttpContext): Observable<SalesArticleDto> {
    return this.apiProductsquerySalesarticlesUrlIdDetailsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SalesArticleDto>): SalesArticleDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesUrlIdDetailsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesUrlIdDetailsGet$Response(params: ApiProductsquerySalesarticlesUrlIdDetailsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesArticleDto>> {
    return apiProductsquerySalesarticlesUrlIdDetailsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesUrlIdDetailsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesUrlIdDetailsGet(params: ApiProductsquerySalesarticlesUrlIdDetailsGet$Params, context?: HttpContext): Observable<SalesArticleDto> {
    return this.apiProductsquerySalesarticlesUrlIdDetailsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<SalesArticleDto>): SalesArticleDto => r.body)
    );
  }

  /** Path part for operation `apiProductsquerySalesarticlesHighlightedGet()` */
  static readonly ApiProductsquerySalesarticlesHighlightedGetPath = '/api/productsquery/salesarticles/highlighted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesHighlightedGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesHighlightedGet$Plain$Response(params?: ApiProductsquerySalesarticlesHighlightedGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsquerySalesarticlesHighlightedGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesHighlightedGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesHighlightedGet$Plain(params?: ApiProductsquerySalesarticlesHighlightedGet$Plain$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsquerySalesarticlesHighlightedGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesHighlightedGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesHighlightedGet$Response(params?: ApiProductsquerySalesarticlesHighlightedGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsquerySalesarticlesHighlightedGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesHighlightedGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesHighlightedGet(params?: ApiProductsquerySalesarticlesHighlightedGet$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsquerySalesarticlesHighlightedGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /** Path part for operation `apiProductsquerySalesarticlesCategoryCategoryIdGet()` */
  static readonly ApiProductsquerySalesarticlesCategoryCategoryIdGetPath = '/api/productsquery/salesarticles/category/{categoryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesCategoryCategoryIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesCategoryCategoryIdGet$Plain$Response(params: ApiProductsquerySalesarticlesCategoryCategoryIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsquerySalesarticlesCategoryCategoryIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesCategoryCategoryIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesCategoryCategoryIdGet$Plain(params: ApiProductsquerySalesarticlesCategoryCategoryIdGet$Plain$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsquerySalesarticlesCategoryCategoryIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesCategoryCategoryIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesCategoryCategoryIdGet$Response(params: ApiProductsquerySalesarticlesCategoryCategoryIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsquerySalesarticlesCategoryCategoryIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesCategoryCategoryIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesCategoryCategoryIdGet(params: ApiProductsquerySalesarticlesCategoryCategoryIdGet$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsquerySalesarticlesCategoryCategoryIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /** Path part for operation `apiProductsquerySalesarticlesBrandBrandGet()` */
  static readonly ApiProductsquerySalesarticlesBrandBrandGetPath = '/api/productsquery/salesarticles/brand/{brand}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesBrandBrandGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesBrandBrandGet$Plain$Response(params: ApiProductsquerySalesarticlesBrandBrandGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsquerySalesarticlesBrandBrandGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesBrandBrandGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesBrandBrandGet$Plain(params: ApiProductsquerySalesarticlesBrandBrandGet$Plain$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsquerySalesarticlesBrandBrandGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesBrandBrandGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesBrandBrandGet$Response(params: ApiProductsquerySalesarticlesBrandBrandGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsquerySalesarticlesBrandBrandGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesBrandBrandGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesBrandBrandGet(params: ApiProductsquerySalesarticlesBrandBrandGet$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsquerySalesarticlesBrandBrandGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /** Path part for operation `apiProductsquerySalesarticlesSummaryIdGet()` */
  static readonly ApiProductsquerySalesarticlesSummaryIdGetPath = '/api/productsquery/salesarticles/summary/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesSummaryIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesSummaryIdGet$Plain$Response(params: ApiProductsquerySalesarticlesSummaryIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesArticleSummary>> {
    return apiProductsquerySalesarticlesSummaryIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesSummaryIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesSummaryIdGet$Plain(params: ApiProductsquerySalesarticlesSummaryIdGet$Plain$Params, context?: HttpContext): Observable<SalesArticleSummary> {
    return this.apiProductsquerySalesarticlesSummaryIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SalesArticleSummary>): SalesArticleSummary => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesSummaryIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesSummaryIdGet$Response(params: ApiProductsquerySalesarticlesSummaryIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesArticleSummary>> {
    return apiProductsquerySalesarticlesSummaryIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesSummaryIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesSummaryIdGet(params: ApiProductsquerySalesarticlesSummaryIdGet$Params, context?: HttpContext): Observable<SalesArticleSummary> {
    return this.apiProductsquerySalesarticlesSummaryIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<SalesArticleSummary>): SalesArticleSummary => r.body)
    );
  }

  /** Path part for operation `apiProductsquerySalesarticlesSummaryIdsGet()` */
  static readonly ApiProductsquerySalesarticlesSummaryIdsGetPath = '/api/productsquery/salesarticles/summary/ids';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesSummaryIdsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesSummaryIdsGet$Plain$Response(params?: ApiProductsquerySalesarticlesSummaryIdsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsquerySalesarticlesSummaryIdsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesSummaryIdsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesSummaryIdsGet$Plain(params?: ApiProductsquerySalesarticlesSummaryIdsGet$Plain$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsquerySalesarticlesSummaryIdsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesSummaryIdsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesSummaryIdsGet$Response(params?: ApiProductsquerySalesarticlesSummaryIdsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsquerySalesarticlesSummaryIdsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesSummaryIdsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesSummaryIdsGet(params?: ApiProductsquerySalesarticlesSummaryIdsGet$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsquerySalesarticlesSummaryIdsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /** Path part for operation `apiProductsquerySalesarticlesTemporarydiscountsGet()` */
  static readonly ApiProductsquerySalesarticlesTemporarydiscountsGetPath = '/api/productsquery/salesarticles/temporarydiscounts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesTemporarydiscountsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesTemporarydiscountsGet$Plain$Response(params?: ApiProductsquerySalesarticlesTemporarydiscountsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsquerySalesarticlesTemporarydiscountsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesTemporarydiscountsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesTemporarydiscountsGet$Plain(params?: ApiProductsquerySalesarticlesTemporarydiscountsGet$Plain$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsquerySalesarticlesTemporarydiscountsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProductsquerySalesarticlesTemporarydiscountsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesTemporarydiscountsGet$Response(params?: ApiProductsquerySalesarticlesTemporarydiscountsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
    return apiProductsquerySalesarticlesTemporarydiscountsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProductsquerySalesarticlesTemporarydiscountsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProductsquerySalesarticlesTemporarydiscountsGet(params?: ApiProductsquerySalesarticlesTemporarydiscountsGet$Params, context?: HttpContext): Observable<Array<SalesArticleSummary>> {
    return this.apiProductsquerySalesarticlesTemporarydiscountsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleSummary>>): Array<SalesArticleSummary> => r.body)
    );
  }

}
